import { urlConfig } from "../../config/urlConfig";
import { DocumentViewerRequestModel } from "../../types/DocumentViewerModel";
import { postCall, postFileDownloadCall } from "../httpService";
import { DocumentsRequestData } from "../../types/DocumentsModel";
import { DocumentView } from "../../types/SimpleSearchModel";

const baseUrl = process.env.REACT_APP_API_URL;
const documentsUrl = urlConfig.DocumentsApi;
const downFileUrl = urlConfig.Searchfiledownload;
const infoUrl = urlConfig.fileInformation;
const deleteDocUrl = urlConfig.deleteDocuments;
const multipleDocsDownloadUrl = urlConfig.multipleDocumentsDownload;
const documentViewerUrl = urlConfig.documentViewer;

export const getDocumentsData = async (
  documentsModel: DocumentsRequestData
) => {
  try {
    const response = await postCall(documentsUrl, documentsModel);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const downloadFile = async (downloadFilePayLoad: any) => {
  try {
    const response = await postFileDownloadCall(
      downFileUrl,
      downloadFilePayLoad
    );
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getDocumentViewer = async (
  docPayload: DocumentViewerRequestModel
) => {
  try {
    const response = await postCall(documentViewerUrl, docPayload);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const GetMultipleDocuments = async (params: any) => {
  try {
    const response = await postFileDownloadCall(
      urlConfig.MultipleDocsDownload,
      params
    );
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const deleteDocuments = async (docPayload: DocumentView[]) => {
  try {
    const response = await postCall(deleteDocUrl, docPayload);
    return response.status;
  } catch (error) {
    console.error("Error in deleteDocuments", error);
    throw error;
  }
};

export const getFoldersByLevels = async (payload: any) => {
  try {
    const response = await postCall(urlConfig.FoldersGetByLevels, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
